const Analytics = () => {

    return (
        <div>
            <h1>
                Pagina Analytics
            </h1>
        </div>
    )
}

export default Analytics